export default __webpack_public_path__ + "static/media/fridge2-afterA-1024w.52ec5c0a.avif";